"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueSearchQueryField = void 0;
var _lodash = require("lodash");
var _testing = require("../utils/testing");
var _simpleSearchQueryField = require("./simple-search-query-field");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class MultiValueSearchQueryField extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, available, selected, defaultSelected) {
    var defaultItems = defaultSelected || [];
    var availableItems = available || [];
    var availableMap = availableItems.reduce((map, value) => _objectSpread(_objectSpread({}, map), {}, {
      [value.name]: value
    }), {});
    var selectedValues = [...new Set(selected ? selected.filter(each => availableMap[each] != null) : defaultItems)];
    super(searchOptions, selectedValues, defaultItems);
    _defineProperty(this, "availableMap", void 0);
    _defineProperty(this, "selected", void 0);
    _defineProperty(this, "available", void 0);
    this.available = availableItems;
    this.availableMap = availableMap;
    this.selected = selectedValues;
  }
  getUrlParameterValue() {
    if (this.isDefault()) {
      return null;
    }
    if (this.isEmpty()) {
      return '';
    }
    var allValues = this.selected.map(each => this.availableMap[each].urlSlug).filter(Boolean);
    return allValues.length > 0 ? allValues.join(',') : null;
  }
  isEmpty() {
    return this.selected ? this.selected.length === 0 : true;
  }
  isDefault() {
    var _this$default;
    return (0, _lodash.isEqual)(this.selected.slice().sort(), (_this$default = this.default) === null || _this$default === void 0 ? void 0 : _this$default.slice().sort());
  }
  hasValue(name) {
    return this.selected.includes(name);
  }
  hasOnlyValue(name) {
    return this.hasValue(name) && this.selected.length === 1;
  }
  getValues() {
    return this.selected;
  }
  getSingleValue() {
    return this.selected && this.selected.length === 1 ? this.selected[0] : null;
  }
  getCondensedValue() {
    return this.isDefault() ? null : this.selected;
  }
  isMultiValueFilter() {
    return true;
  }
  static isInstance(value) {
    return (0, _testing.isA)(value, 'MultiValueFilter');
  }
}
exports.MultiValueSearchQueryField = MultiValueSearchQueryField;